import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { X, FileText, IndianRupee, CalendarCheck } from "lucide-react";
import { useEnquiry } from "../enquiryContext";
import LeadForm from "./LeadForm";
import { ONE_WORLD, NEOPOLIS } from "../content";

export default function EnquiryPopup() {
  const { isOpen, closePopup, project, config, intent } = useEnquiry();
  const { pathname } = useLocation();
  const resolvedProject = project || (pathname.includes("sobha-neopolis") ? NEOPOLIS : ONE_WORLD);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          data-testid="enquiry-popup"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] bg-ink/80 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-6"
          onClick={closePopup}
        >
          <motion.div
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 60, opacity: 0 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative bg-ink border border-gold/25 w-full sm:max-w-3xl max-h-[92svh] overflow-y-auto grid md:grid-cols-2"
          >
            <button
              data-testid="enquiry-popup-close"
              onClick={closePopup}
              aria-label="Close"
              className="absolute top-4 right-4 z-10 w-9 h-9 border border-[#F9F8F6]/25 text-[#F9F8F6]/80 flex items-center justify-center hover:border-gold hover:text-gold transition-colors"
            >
              <X size={16} />
            </button>

            <div className="hidden md:block relative">
              <img
                src={resolvedProject.heroImages[0]}
                alt={resolvedProject.name}
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-ink/55" />
              <div className="relative h-full flex flex-col justify-end p-8">
                <p className="text-[10px] uppercase tracking-[0.28em] text-gold mb-3">{intent}</p>
                <p className="font-serif-display text-3xl text-[#F9F8F6] leading-tight">
                  {resolvedProject.name}
                </p>
                <p className="mt-2 text-sm font-normal text-[#F9F8F6]/75">
                  {resolvedProject.priceTag}
                </p>
              </div>
            </div>

            <div className="p-6 md:p-9">
              <p className="text-[10px] uppercase tracking-[0.28em] text-gold mb-2 md:hidden">{intent}</p>
              <h3 className="font-serif-display text-2xl md:text-[28px] text-[#F9F8F6] leading-snug">
                {intent} — sent to your WhatsApp
              </h3>
              <div className="mt-5 space-y-2.5 mb-7">
                {[
                  [IndianRupee, "Latest pricing & payment plans"],
                  [FileText, "Brochure & floor plans"],
                  [CalendarCheck, "Free guided site visit"],
                ].map(([Icon, text]) => (
                  <div key={text} className="flex items-center gap-3 text-[13px] font-normal text-[#F9F8F6]/75">
                    <Icon size={15} strokeWidth={1.5} className="text-gold shrink-0" />
                    {text}
                  </div>
                ))}
              </div>
              <LeadForm project={resolvedProject} config={config} intent={intent} compact idPrefix="popup" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
